import * as React from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography } from '@mui/material'

export default function ManageJob() {
  return (
    <div>
      <h1>ManageJob page</h1>
    </div>
  )
}
